//var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');
import $ from 'jquery'
import Isotope from 'isotope-layout'
import 'bootstrap-select'


$(function () {

	if ($('.reference-overview').length) {
		/* init Isotope */
		var $grid = document.querySelector<HTMLDivElement>('.reference-grid');
		var iso : Isotope | null | undefined

		$grid && imagesLoaded($grid, function () {
		// init Isotope after all images have loaded
			iso = $grid && new Isotope($grid, {
				itemSelector: '.reference-grid-item',
				filter: '*',
				layoutMode: 'fitRows'
			})
		})
			
		// Filter
		let $selects = $<HTMLSelectElement>('.reference-overview .item-select');

		$selects.on('change',function () {

			// map input values to an array
			var aexclusives: string[] = []
			var inclusives: string[] = []
			// exclusive filters from selects
			$selects.each(function (i, elem) {
				if (elem.value) {
					aexclusives.push(elem.value);
				}
			});

			// combine exclusive and inclusive filters
			// first combine exclusives
			let exclusives = aexclusives.join('');

			var filterValue;
			if (inclusives.length) {
				// map inclusives with exclusives for
				filterValue = $.map(inclusives, function (value) {
					return value + exclusives;
				});
				filterValue = filterValue.join(', ');
			} else {
				filterValue = exclusives;
			}

			iso?.arrange({
				filter: filterValue
			});
		});

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
			$('.item-select').selectpicker('mobile');
			var $bootstrapSelects = $('.item-select');
		} else {
			$('.item-select').selectpicker();
			var $bootstrapSelects = $('.item-select .dropdown-toggle');
		}

		$bootstrapSelects.on('click touchstart', function () {
			var selectValues: (string | undefined)[] = []

			if ($(this).hasClass('bootstrap-select')) {
				var $currentBtSelect = $(this);
			} else {
				var $currentBtSelect = $(this).closest('.bootstrap-select');
			}
			var $currentSelect = $currentBtSelect.find('select');

			var $filterGrid = $(this).closest('.reference-overview').find('.reference-grid');
			var $filterGridItems = $filterGrid.find('.reference-grid-item');
			var possibleFilterGridItems = [];

			$selects.not($currentSelect).each(function () {
				if ($(this).val()) {
					selectValues.push($(this).val()?.toString().replace('.', ''));
				}
			});

			function containsAll(needles: any[], haystack: any[] = []): boolean {
				for (var i = 0, len = needles.length; i < len; i++) {
				if ($.inArray(needles[i], haystack) == -1) return false
				}
				return true
			}

			$filterGridItems.each(function () {
				let $classes = $(this).attr("class")?.split(' ');
				if (containsAll(selectValues, $classes)) {
					possibleFilterGridItems.push(String($(this).attr('class')?.split(' ')));
				}
			});
			var $currentSelectOptions = $currentSelect.find('option')

			$currentSelectOptions.each(function () {
				var $currentOption = $(this)
				//console.log('Option: -'+$currentOption.val()+'-');

				if ($currentOption.val()) {
					var $checkOption = $(this).val()?.toString().replace('.', '')
					var $possibleFilterGridCount = possibleFilterGridItems.length
					//console.log('Anzahl möglicher Items: '+$possibleFilterGridCount);

					let $optionExists = false
					for (var i = 0; i < $possibleFilterGridCount; i++) {
						let possibleFilterGridItemsArray = possibleFilterGridItems[i].split(',')
						if (possibleFilterGridItemsArray.includes(String($checkOption))) {
							$optionExists = true
						}
					}
					if ($optionExists) {
						$currentOption.prop('disabled', false)
						//console.log($checkOption+' gibt es');
					} else {
						$currentOption.prop('disabled', 'disabled')
						//console.log($checkOption+' gibt es nicht');
					}
				}
			})
			$('.item-select').selectpicker('refresh');

		});
	}
});